import React from "react";
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import avatar from "../../../../../assets/images/users/user-dummy-img.jpg";

const ReadMoreModal = ({ modalTestimonial, showModal, closeModal }) => {
  return (
    <>
      <Modal isOpen={showModal} toggle={closeModal} size="lg">
        <ModalHeader>
          <h5>"{modalTestimonial && modalTestimonial.title}"</h5>
        </ModalHeader>
        <ModalBody className="m-2">
          <p>{modalTestimonial && modalTestimonial.description}</p>

          <Row className="p-2 m-1" style={{ backgroundColor: "#E1EFFF" }}>
            <Col md={6} className="d-flex gap-3 mb-2">
              <img
                src={
                  (modalTestimonial && modalTestimonial.profile_image?.path) ||
                  avatar
                }
                className="rounded-circle avatar-md"
                style={{ width: "50px", height: "50px" }}
                alt={`${modalTestimonial && modalTestimonial.name}'s profile`}
              />
              <div className="d-flex flex-column mt-1">
                <h6>{modalTestimonial && modalTestimonial.name}</h6>
                <small className="text-muted">
                  {modalTestimonial && modalTestimonial.country}
                </small>
              </div>
            </Col>

            <Col
              md={6}
              className="text-end d-flex align-content-center align-items-center justify-content-center"
            >
              <h6>Package:{modalTestimonial?.package?.page_title}</h6>
            </Col>
          </Row>

          <div></div>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center align-content-center">
          <button className="btn btn-outline-info" onClick={closeModal}>
            Done Reading
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default ReadMoreModal;
